import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01fdecf1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=01fdecf1&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=01fdecf1&prod&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=01fdecf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdecf1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
